"use client";

import { useEffect } from "react";
import { useCookieConsent } from "@/lib/cookie-consent";

function mapConsentToGoogleParams(consent: {
  statistics: boolean;
  marketing: boolean;
}) {
  return {
    analytics_storage: consent.statistics ? "granted" : "denied",
    ad_storage: consent.marketing ? "granted" : "denied",
    ad_user_data: consent.marketing ? "granted" : "denied",
    ad_personalization: consent.marketing ? "granted" : "denied",
  } as const;
}

export function ConsentModeUpdater() {
  const { consent } = useCookieConsent();

  useEffect(() => {
    if (!consent) return;
    if (typeof window.gtag === "function") {
      window.gtag("consent", "update", mapConsentToGoogleParams(consent));
    }
  }, [consent]);

  return null;
}
